export default __webpack_public_path__ + "static/media/reset.5ada7b42.png";